module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_high_img4.6ad2a3f3.png";